<template>
  <v-card class="a-kpi-main text-center pa-2" flat v-on="$listeners">
    <h3 v-if="title" class="text-subtitle-1">{{ title }}</h3>
    <h1 class="text-h3">
      {{ format(value) }}
      <sup
        v-if="delta"
        :class="{
          negative: delta < 0
        }"
      >
        {{ delta > 0 ? "+" : "" }}{{ Math.round(delta) }}%
      </sup>
    </h1>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    format: {
      type: Function,
      default: v => v
    },
    title: {
      type: String,
      default: null
    },
    delta: {
      type: Number,
      default: null
    }
  }
};
</script>

<style lang="scss">
.a-kpi-main {
  min-width: 128px;
  border-radius: 4px * 3;

  h1 {
    sup {
      font-size: 0.8rem;
      font-weight: bold;
      color: var(--v-darkGreen-lighten1);

      top: -2em;
      margin-left: -1em;

      &.negative {
        color: var(--v-error-darken2);
      }
    }
  }

  &.v-card--link:hover {
    background: var(--v-lightGrey-base);
  }
}
</style>
